
import {
  defineComponent, computed, PropType
} from 'vue';
import { BCXExtendedDropdownItem } from '@/components/molecules/forms/BCXMultiselectSection.vue';
import { useVModel } from '@vueuse/core';
import useI18n from '@/mixins/useI18n';
import BCXMultiselectFilter from '@/components/molecules/BCXMultiselectFilter.vue';
import { audienceOptions } from '@/models/BlogAudience';

export default defineComponent({
  name: 'BlogEntryAudienceFilter',
  components: {
    BCXMultiselectFilter
  },
  props: {
    value: {
      type: Array as PropType<BCXExtendedDropdownItem[]>,
      default: () => [],
      required: true
    }
  },
  setup(props) {
    const { t } = useI18n();
    const audienceSelected = useVModel(props);
    const audienceItems = computed(() => audienceOptions().map((key) => ({ value: key, label: key })));
    return {
      t,
      audienceSelected,
      audienceItems
    };
  }
});
